import { render, staticRenderFns } from "./PaymentLotteryForm.vue?vue&type=template&id=a64813ca"
import script from "./PaymentLotteryForm.vue?vue&type=script&lang=js"
export * from "./PaymentLotteryForm.vue?vue&type=script&lang=js"
import style0 from "./PaymentLotteryForm.vue?vue&type=style&index=0&id=a64813ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports